var SortedMap = require("../collections/sortedMap.js");
var getSetFunctionCreator = require("./getsetFunction.js");
var sanityCheckHandler = require("./sanityCheckHandler.js");

function error_getter() { throw new Error("Getter of shadow not defined"); }
function error_setter() { throw new Error("Setter of shadow not defined"); }

var ObservableShadow = function(getter, setter, sensitivityList, thisArg){
    this._value = null;
    this._dirty = true;

    this.getter = getter || error_getter;
    this.setter = setter || error_setter;
    this.thisArg = thisArg;

    this.handlers = {
        change: null,
        setFail: null,
        setPass: null
    };

    this.triggers = [];
    for (var i in sensitivityList){
        var trigger = sensitivityList[i];
        if(trigger instanceof Array) {
            console.assert(trigger[0] && trigger[1], "Invalid trigger");
            this.addTrigger(trigger[0], trigger[1], trigger[2]);
        } else {
            this.addTrigger(trigger);
        }
    }
};
ObservableShadow.createNewFunction = getSetFunctionCreator;

ObservableShadow.prototype.getType = function(){return "shadow";};

ObservableShadow.prototype.get = function(){
    if (this._dirty){
        this._value = this.getter.call(this.thisArg);
        this._dirty = false;
    }
    return this._value;
};

ObservableShadow.prototype.set = function(val){
    var validated = this.setter.apply(this.thisArg, arguments);
    if(!validated) {
        if(this.handlers.setFail)
            this.handlers.setFail.forEach(function(k, handler){
                handler();
            });
    } else {
        if(this.handlers.setPass)
            this.handlers.setPass.forEach(function(k, handler){
                handler();
            });
    }
    return validated;
};


ObservableShadow.prototype.setDirty = function(trigger){
    var self = this;
    this._dirty = true; // only set this shadow dirty, don't recalculate value prematurely
    this.handlers.change && this.handlers.change.forEach(function(k, handler){  // TODO: maybe change this in onTrigger handlers since you don't know anything about current or previous value yet
        handler.call(self);
    });
};

ObservableShadow.prototype.addTrigger = function(trigger, handler, filter){
    var self = this;
    var setDirty = function(args){
        var trigger = this;
        if (filter == undefined || filter.apply(null, arguments)) self.setDirty(trigger);  // trigger is used as this when calling this function
    };
    if (handler) handler.call(trigger, this, setDirty);
    else { // if no handler is passed, add the existing default handlers
        if (trigger.onChange) trigger.onChange(this, setDirty);
        if (trigger.onAdd) trigger.onAdd(this, setDirty);
        if (trigger.onPut) trigger.onPut(this, setDirty);
        if (trigger.onRemove) trigger.onRemove(this, setDirty);
    }
    this.triggers.push(trigger);
};

ObservableShadow.prototype.removeTrigger = function(trigger){
    trigger.removeHandlers(this);
    this.triggers.splice(this.triggers.indexOf(trigger), 1);
};

ObservableShadow.prototype.removeAllTriggers = function(){
    for (var type in this.triggers){
        if(this.handlers[type])
            this.triggers[type].removeHandlers(this);
    }
    this.triggers = [];
};

ObservableShadow.prototype.onChange = function(key, handler, priority) {  // handlers without priority get default priority 0 and are sorted in insertion order
    sanityCheckHandler(arguments);
    if(!this.handlers.change) this.handlers.change = new SortedMap();
    this.handlers.change.put(key, handler, priority || 0);
};

ObservableShadow.prototype.onSetFail = function(key, handler, priority) {
    sanityCheckHandler(arguments);
    if(!this.handlers.setFail) this.handlers.setFail = new SortedMap();
    this.handlers.setFail.put(key, handler, priority || 0);
};

ObservableShadow.prototype.onSetPass = function(key, handler, priority) {
    sanityCheckHandler(arguments);
    if(!this.handlers.setPass) this.handlers.setPass = new SortedMap();
    this.handlers.setPass.put(key, handler, priority || 0);
};

ObservableShadow.prototype.removeHandlers = function(key){
    for (var type in this.handlers){
        if(this.handlers[type]) {
            this.handlers[type].remove(key);
            this._cleanHandlers(type);
        }
    }
};

ObservableShadow.prototype.removeAllHandlers = function(col) {
    for (var type in this.handlers) {
        if(this.handlers[type]) {
            this.handlers[type].removeAll(col);
            this._cleanHandlers(type);
        }
    }
};

ObservableShadow.prototype.removeHandlersWhere = function(f){
    for (var type in this.handlers){
        if(this.handlers[type]) {
            this.handlers[type].removeWhere(f);
            this._cleanHandlers(type);
        }
    }
};

ObservableShadow.prototype._cleanHandlers = function(type) {
    if(this.handlers[type].size() == 0)
        this.handlers[type] = null;
};

module.exports = ObservableShadow;
